import type { FC, ReactNode } from 'react'
import type { LayoutProps } from '@/types'

import { SiteFooter } from '@/components/generals/site-footer'

/**
 * Page body shared by every page. The page sits above the footer and carries its own cream
 * background, so scrolling to the end slides it away to uncover the footer.
 */
export const Layout: FC<LayoutProps> = ({ children }): ReactNode => {
    return (
        <>
            <main id='main' tabIndex={-1} className='relative z-[1] min-h-screen overflow-x-clip bg-background outline-none'>
                {children}
            </main>

            <SiteFooter />
        </>
    )
}
